import { useEffect, useState } from "react";

const useTimer = (initialTime, speed = 1000) => {
  const [timer, setTimer] = useState(initialTime);
  const [isTimerStart, setIsTimerStart] = useState(true);

  // convert time to "00:00" format
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (time % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  // create timer
  useEffect(() => {
    let timerInterval;

    // if timer is off start the timer
    if (isTimerStart) {
      timerInterval = setInterval(() => {
        // reduce time based on speed
        setTimer((prevTime) => prevTime - 1);
      }, speed);
    }

    // kill timer interval when component didmount
    return () => clearInterval(timerInterval);
  }, [isTimerStart, speed]);

  // set timer off or on based on timer value
  useEffect(() => {
    if (timer === 0) {
      setIsTimerStart(false);
      setTimer(initialTime);
    }
  }, [timer, initialTime]);

  return { timer: formatTime(timer), isTimerStart, setIsTimerStart ,setTimer };
};

export default useTimer;

// this hook is for creating timer based on given initial time and speed
//  in args and returns timer number and timer starting state and also function
//  to start timer manualy
